<template>
    <div id="loong">
      <Navbar />
      <router-view></router-view>
      <div class="placeholder"></div>
      <!-- <Bottombar /> -->
    </div>
  </template>
  
  <script>
  import Navbar from '@/views/Loong/Navbar.vue'
  export default {
    name: 'App',
    components: {
      Navbar
    }
  }
  </script>
  
  <style>
  #loong {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }

  .el-container {
      margin-bottom: 20px;
      margin-top: 20px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      min-height: 10em;
    }
  .placeholder{
    height: 50px
  }
  </style>
  